/* ─────────────────────────────────────────
   section-product-tabs.js
───────────────────────────────────────── */

(function () {
  'use strict';

  function initTabs(section) {
    const sectionId = section.dataset.sectionId;
    const tabs      = section.querySelectorAll('.tab-button');
    const panels    = section.querySelectorAll('.product-tabs__panel');

    if (!tabs.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;

        // Deactivate all tabs
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        // Hide all panels
        panels.forEach(p => {
          p.classList.remove('active');
          p.setAttribute('hidden', '');
        });

        // Activate clicked tab
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        // Show matching panel
        const panel = section.querySelector('#tab-panel-' + target + '-' + sectionId);
        if (panel) {
          panel.classList.add('active');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-tabs').forEach(initTabs);
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') init();
    });
  }

})();